import { useEffect, useState } from "react";
import axios from "axios";
import { useAuth } from '../contexts/AuthContext';

function getAuthHeaders(token, origin) {  
  return {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
            'Access-Control-Allow-Origin': origin,
            'ngrok-skip-browser-warning': 'skip-browser-warning',
        },
  };
}

// Unused
function useGetFetch(url) {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(false);// not sure why I did this, since first render is always loading, therefore showing the set loading, gonna leave for now.
    const [error, setError] = useState(null);
  
    useEffect(() => {
        const fetchData = async () => {
            setLoading(true); // ^
            try {
                const response = await axios.get(url);
                setData(response.data);
            } catch (err) {
                setError(err);
            } finally {
                setLoading(false);
            }
        };
  
        fetchData();
    }, [url]);
  
    const refetch = async () => {
        setLoading(true);
        try {
            const response = await axios.get(url);
            setData(response.data);
        } catch (err) {
            setError(err);
        } finally {
            setLoading(false);
        }
    };
  
    return { data, loading, error, refetch };
}

// Unused
function useAuthGetFetch(url) {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const { getAuthToken } = useAuth();
  
    useEffect(() => {
        const fetchData = async () => {
            try {
                const token = await getAuthToken();
                const headers = getAuthHeaders(token, url);
                const response = await axios.get(url, headers);
                setData(response.data);
            } catch (err) {
                setError(err);
            } finally {
                setLoading(false);
            }
        };
  
        fetchData();
    }, [url]);
  
    const refetch = async () => {
        try {
            const token = await getAuthToken();
            const headers = getAuthHeaders(token, url);
            const response = await axios.get(url, headers);
            setData(response.data);
        } catch (err) {
            setError(err);
        } finally {
            setLoading(false);
        }
    };
  
    return { data, loading, error, refetch };
}

// Unused
function useAuthPostFetch() {
  
    const [codeFromPost, setCode] = useState(null);
    const [posting, setPosting] = useState(false);
    const [postError, setError] = useState(null);
    const { getAuthToken } = useAuth();
  
    async function post(url, data) {
        setPosting(true);
        let response;
        try {
            const token = await getAuthToken();
            const headers = getAuthHeaders(token, url);
            response = await axios.post(url, data, headers);
            setCode(response.status);
        } catch (err) {
            setError(err.status || 'Error');
        } finally {
            setPosting(false);
            return response;
        }
    }

    return { codeFromPost, posting, postError, post };
}

function useAuthPost(useLoading = false, initialLoading = false) {
    const { getAuthToken } = useAuth();
    const [loading, setLoading] = useState(initialLoading);

    async function post(url, data) {
        try {
            if (useLoading) {
                setLoading(true);
            }
            const token = await getAuthToken();
            const headers = getAuthHeaders(token, url);
            const response = await axios.post(url, data, headers);
            return response;
        } catch (err) {
            throw err;
        } finally {
            if (useLoading) {
                setLoading(false);
            }
        }
    }

    return { post, loading };
}

function useAuthDelete() {
    const { getAuthToken } = useAuth();

    async function del(url) {
        const token = await getAuthToken();
        const headers = getAuthHeaders(token, url);
        return axios.delete(url, headers);
    }

    return { del };
}

function useAuthGet() {
    const { getAuthToken } = useAuth();
    async function get(url) {
        const token = await getAuthToken();
        const headers = getAuthHeaders(token, url);
        return axios.get(url, headers);
    }
    
    return { get };
}

export { useGetFetch, useAuthPost, useAuthGetFetch, useAuthDelete, useAuthPostFetch, useAuthGet };